module.exports = __webpack_public_path__ + "static/media/user.0ad3d311.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/_common/ProfileMenu/user.svg
// module id = 1422
// module chunks = 0